import { render, staticRenderFns } from "./VkImputBuilder.vue?vue&type=template&id=53e2f942&"
import script from "./VkImputBuilder.vue?vue&type=script&lang=ts&"
export * from "./VkImputBuilder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports